import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaMoneyBillAlt,FaParking,FaBaby,FaToilet } from 'react-icons/fa'
import styles from './services.module.css'

export default function Services(props) {
    return (
        <>
            <h4 className="m-2"><u>Services</u></h4>
            {props.services.atm ?
                <OverlayTrigger placement="bottom" delay={{ show: 150, hide: 300 }} overlay={<Tooltip>ATM</Tooltip>}>
                    <span className={`${styles.icon} p-1 mx-2`}><FaMoneyBillAlt/></span>
                </OverlayTrigger>
                : <></>}
            {props.services.babyChange ?
                <OverlayTrigger placement="bottom" delay={{ show: 150, hide: 300 }} overlay={<Tooltip>Baby Changing Facilities</Tooltip>}>
                    <span className={`${styles.icon} p-1 mx-2`}><FaBaby/></span>
                </OverlayTrigger>
                : <></>}
            {props.services.parking ?
                <OverlayTrigger placement="bottom" delay={{ show: 150, hide: 300 }} overlay={<Tooltip>Parking</Tooltip>}>
                    <span className={`${styles.icon} p-1 mx-2`}><FaParking/></span>
                </OverlayTrigger>
                : <></>}
            {props.services.toilets ?
                <OverlayTrigger placement="bottom" delay={{ show: 150, hide: 300 }} overlay={<Tooltip>Toilets</Tooltip>}>
                    <span className={`${styles.icon} p-1 mx-2`}><FaToilet/></span>
                </OverlayTrigger>
                : <></>}
        </>
    )
}
